import { createContext, useContext, useState, ReactNode } from 'react'

interface ProgressModalContextType {
  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void
}

const ProgressModalContext = createContext<ProgressModalContextType | undefined>(undefined)

export const useProgressModal = () => {
  const context = useContext(ProgressModalContext)
  if (!context) {
    throw new Error('useProgressModal must be used within ProgressModalProvider')
  }
  return context
}

interface ProgressModalProviderProps {
  children: ReactNode
}

export const ProgressModalProvider = ({ children }: ProgressModalProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <ProgressModalContext.Provider value={{ isModalOpen, setIsModalOpen }}>
      {children}
    </ProgressModalContext.Provider>
  )
}
